// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeOffHolidays_wrapper__qByl+","controls":"TimeOffHolidays_controls__tzloq","searchWrapper":"TimeOffHolidays_searchWrapper__2PH3x"};